module.exports = __webpack_public_path__ + "static/img/img3.af39f79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img3.png
// module id = ro8C
// module chunks = 23